import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./TeamProfile.css";

function TeamProfile() {

  const { id } = useParams();
  const [user, setUser] = useState(null);

  useEffect(() => {

    fetch(`http://localhost/aignosi_site/api/team/${id}`)
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          setUser(data.data);
        }
      })
      .catch(err => console.log(err));

  }, [id]);

  if (!user) return <h2 className="loading">Loading...</h2>;

  const image = user._pic
    ? `http://localhost/aignosi_site/assets/team/${user._pic}`
    : `http://localhost/aignosi_site/assets/team/defimg.png`;

  return (
    <div className="profile-page">

      <div className="profile-container">

        <div className="profile-image">
          <img src={image} alt="profile" />
        </div>

        <h2>{user._name}</h2>
        <p className="designation">{user._desig}</p>

        <div className="profile-details">
          <p><b>ID:</b> {user._emp_id}</p>
          <p><b>Email:</b> {user._mail}</p>
          <p><b>Contact:</b> {user._contact}</p>
        </div>

        <div className="company-info">

          <div className="company-header">
            <img
              src="http://localhost/aignosi_site/assets/team/headlogo.png"
              alt="Company Logo"
            />
            <h3>IGNOSI Enterprises LLP</h3>
          </div>

          <p>
            G3B, KSUM, Thejaswini Building <br/>
            Technopark Trivandrum - 695581 <br/>
            +91 9447 094 230, +91 9400 292 295 <br/>
            info@ignosi.in
          </p>

          {user._description && (
            <a
              className="save-contact-btn"
              href={`http://localhost/aignosi_site/haR5KRvqeV/${user._description}.vcf`}
            >
              Save Contact
            </a>
          )}

        </div>

      </div>

    </div>
  );
}

export default TeamProfile;